export default __webpack_public_path__ + "static/media/plain-sticker-N.fa4af4fe.png";